// The ONE API host of the Brightivity web app (ADR-006). VITE_API_BASE is for local
// development against `wrangler dev` only; production builds always use brightivity.dev.
export const API_BASE = (import.meta.env.VITE_API_BASE || 'https://brightivity.dev').replace(/\/+$/, '');
export const APP_VERSION = __APP_VERSION__;
